import { render, staticRenderFns } from "./CambioStatusCard.vue?vue&type=template&id=191cab2a&"
import script from "./CambioStatusCard.vue?vue&type=script&lang=js&"
export * from "./CambioStatusCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports